import React, {useEffect, useState} from 'react';
import { VideoLoader} from '../components/UXHelper';
import { ExtinctionVideoData, ExtinctionData } from '../components/feactures/dataProvider';
import { LoadRadiationTable } from '../components/feactures/dataFetcher';
import { LayoutContainer } from './layouts/layout_bi_columns';
import './styles/blackmarket.css';
import { ShopStands } from '../components/ShopStands';
import { ModalNotify, ModalBtnChildren } from '../components/Modals';
import { useNavigate } from 'react-router-dom';


export const BlackMarket = ({userData, showLoader, closerLoader, onRefreshBalances, pricesFees}) => {

  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  const [radiationData, setRadiationData] = useState({
    status: false,
  })

  const [checkout, setCheckout] = useState({
    status: false,
    value: '',
    price: '',
    discPrice: '',
  })

  const navigate = useNavigate();

  useEffect(() => {
    if(userData.isConnected){
      getInfoRadiation(userData.username)
    }
    return () => {
      setRadiationData({
        status: false,
    
      })
    }
  }, [userData.isConnected]);

  const getInfoRadiation = (account) => {
    LoadRadiationTable(account).then(x => setRadiationData(x)) 
  }
  const handleChange = (evt) => {
    const {value} = evt.target;
    setCheckout((state) => ({
      ...state,
      value: value,
    }))
  }

  const purchase = async(amount, discamount) => {
    let code = checkout.value;
    let price = amount;
    if(Number(code.length) === 0){
      code = ExtinctionData.EXTINCTION_CONTRACT;
    }
    else{
      price = discamount;
    }
    if(userData.whichProvider === 'Anchor'){
      try{
          const action = {
            account: ExtinctionData.ONYX_CONTRACT,
            name: 'purchaseitem',
            authorization: [userData.auths],
            data: {
              from: userData.username,
              to: ExtinctionData.EXTINCTION_CONTRACT,
              quantity: price,
              code: code,
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
            onRefreshBalances();
            setCheckout({status: false, value: '', price: '', discPrice: '',})
            
          })
      }catch(err){
        
      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
        try{
            const action = {
                actions: [{
                    account: ExtinctionData.ONYX_CONTRACT,
                    name: 'purchaseitem',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                        from: userData.username,
                        to: ExtinctionData.EXTINCTION_CONTRACT,
                        quantity: price,
                        code: code,
                      },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setNotify({
                status: true,
                error: false,
                title: 'Success',
                msg: 'Transaction Id:',
                txId: transaction.transaction_id,
              });
              setCheckout({status: false, value: '', price: '', discPrice: '',})
              onRefreshBalances();

          }
          catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
          }
    }
  }

  const PushUrl = (url) => {
    navigate(url);
  }

  if(!userData.isConnected){
      return (
          <div className='signIn_box'>
              <h2 className='signIn-letter'>You need to sign in before!</h2>
          </div>
      )
  }
  
  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

  if(!radiationData.status){
    return(
      <LayoutContainer styles_element={{backgroundColor: '#161617'}}>
              <div className='cointainer_bm_main'>
                <div className='cta_RA_bm'>
                  <h2>Blackmarket is only available to alliance members</h2>
                  <button onClick={() => PushUrl('/RA')}>Go to Radiation Alliance</button>
                </div>
              </div>
          </LayoutContainer>
    )
  }
    
  return (
          <LayoutContainer styles_element={{backgroundColor: '#161617'}}>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
            {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                      setNotify({
                          status: false,
                          error: false,
                          title: '',
                          msg: '',
                          txId: '',
                      })
            }}/>}
            </div>
            {checkout.status &&
              <ModalBtnChildren closeModal={() => setCheckout({status: false, value: '', price: '', discPrice: '',})}>
                <div className='checkout_structer'>
                  <div className='header_checkout_box'>
                    <h3>Enter Discount Code:</h3>
                  </div>
                  <div className='body_checkout_box'>
                    <input type="text" placeholder={`Enter Creator's Code`} value={checkout.value} onChange={handleChange}/>
                    <span className='init_note_input'>**If you don't have a code, just press the buttom below.</span>
                  </div>
                  <div className='footer_checkout_box'>
                    <button className='alt_btn' onClick={() => {
                      const price = checkout.price;
                      const priceDisc = checkout.discPrice;
                      purchase(price, priceDisc);
                      setCheckout((state) => ({
                        ...state,
                        value: '',
                      }))
                    }}>Purchase Now</button>
                  </div>
                </div>
              </ModalBtnChildren>
            }
              <div className='cointainer_bm_main'>
                <ShopStands title={'Train Kit'} descpShort={'Specials Kits'} price={pricesFees.trainkitfee} imgToShow={'https://extinctionwars.com/assets/img/app-resources/blackmarket/trainkit_sale.png'} ctaMsg={'buy now'} buyAction={() => {
                  const amountToBuy = pricesFees.trainkitfee;
                    purchase(amountToBuy);
                }} id={1}/>

                <ShopStands title={'Weapon Crate'} descpShort={'Starter Crate'} price={pricesFees.crateWeapon} imgToShow={'https://extinctionwars.com/assets/img/app-resources/blackmarket/weapon_crate.png'} ctaMsg={'buy now'} buyAction={() => {
                  const amountToBuy = pricesFees.crateWeapon;
                  const disctToBuy = pricesFees.discWep;
                  if(Number(pricesFees.onSale) === 1){
                    setCheckout((state) => ({
                      ...state,
                      status: true,
                      price: amountToBuy,
                      discPrice: disctToBuy,
                    }))
                  }
                }} id={2}/>

                <ShopStands title={'Double Crate'} descpShort={'Starter Crate'} price={pricesFees.crateDouble} imgToShow={'https://extinctionwars.com/assets/img/app-resources/blackmarket/double_crate.png'} ctaMsg={'buy now'} buyAction={() => {
                  const amountToBuy = pricesFees.crateDouble;
                  const disctToBuy = pricesFees.discDouble;
                  if(Number(pricesFees.onSale) === 1){
                    setCheckout((state) => ({
                      ...state,
                      status: true,
                      price: amountToBuy,
                      discPrice: disctToBuy,
                    }))
                  }
                }} id={3}/>

                <ShopStands title={'Suit Crate'} descpShort={'Starter Crate'} price={pricesFees.crateSuit} imgToShow={'https://extinctionwars.com/assets/img/app-resources/blackmarket/suit_crate.png'} ctaMsg={'buy now'} buyAction={() => {
                  const amountToBuy = pricesFees.cratesuit;
                  const disctToBuy = pricesFees.discSuit;
                  if(Number(pricesFees.onSale) === 1){
                    setCheckout((state) => ({
                      ...state,
                      status: true,
                      price: amountToBuy,
                      discPrice: disctToBuy,
                    }))
                  }
                }} id={4}/>
              </div>
          </LayoutContainer>
  )
}
